import { PublicUrls } from '../constants/publicUrls.types';

import { isDev, skipRedirectOnDev } from './EnvUtils';

import { ReleaseGroup } from '@/components/login/login.types';
import sentryService from '@/services/sentry/sentry.service';

let publicUrls: PublicUrls;

async function getPublicUrls() {
  const path = isDev ? '/public-urls-dev.json' : '/public-urls.json';
  const response = await fetch(path);
  const data = await response.json();
  return data as PublicUrls;
}

export async function initPublicUrls() {
  try {
    publicUrls = await getPublicUrls();
  } catch (error) {
    const publicUrlError = new Error(`Failed to load publicUrls: ${error}`);
    sentryService.captureException(publicUrlError);
  }
}

export function redirectAfterAuthentication(releaseGroup: ReleaseGroup) {
  if (!publicUrls) {
    sentryService.captureException(new Error('publicUrls is not initialized'));
    return;
  }
  const portalHost = releaseGroup === 'canary' ? publicUrls.portalCanary : publicUrls.portal;
  
  if (skipRedirectOnDev) {
    return console.log(`dev-mode - skipping redirect to: ${portalHost}`);
  }
  window.location = `${window.location.protocol}//${portalHost}` as Location & string;
}